import { StepType } from "../../step";

export const getStepWithUpdatedIsPassed = (
  step: StepType,
  index: number,
  newPassedStepIndex: number,
  isPassed?: boolean
) => {
  if (newPassedStepIndex === index) {
    return { ...step, ...{ isPassed } };
  }

  return step;
};
